"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNavigationListButton = exports.Container = exports.Heading = exports.RegionsWrapper = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const grid_1 = __importDefault(require("../grid"));
const typography_1 = __importDefault(require("../typography"));
// Have to specify exact file to stop recursive import
const NavigationListButton_1 = require("../navigation/NavigationListButton");
const PREFIX = "LanguageSelection";
exports.classes = {
    languageIcon: `${PREFIX}-languageIcon`
};
exports.RegionsWrapper = (0, styles_1.styled)(grid_1.default)(({ theme }) => ({
    [theme.breakpoints.up("lg")]: {
        flexWrap: "nowrap",
        gap: "22px"
    }
}));
exports.Heading = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    marginTop: "32px",
    marginBottom: "16px",
    [theme.breakpoints.down("lg")]: {
        marginTop: "24px"
    }
}));
exports.Container = (0, styles_1.styled)("div")(({ theme }) => ({
    height: "460px",
    columnCount: 3,
    columnFill: "auto",
    [theme.breakpoints.down(1024)]: {
        height: "calc(100% - 56px)"
    },
    [theme.breakpoints.down("lg")]: {
        columnCount: "unset",
        height: "auto"
    }
}));
exports.StyledNavigationListButton = (0, styles_1.styled)(NavigationListButton_1.NavigationListButton)(({ theme }) => ({
    justifyContent: "start",
    width: "100%",
    margin: 0,
    lineHeight: "22px",
    whiteSpace: "pre-line",
    fontSize: "16px",
    padding: "4px 10px",
    minWidth: "230px",
    color: theme.colours.charcoal,
    [theme.breakpoints.down(1024)]: {
        minWidth: "unset",
        whiteSpace: "normal"
    },
    [theme.breakpoints.down("lg")]: {
        padding: "6px 10px",
        whiteSpace: "pre-line"
    },
    [`.${exports.classes.languageIcon}`]: {
        marginRight: "10px",
        width: "20px"
    }
}));
//# sourceMappingURL=data:application/json;base64,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